module.exports = __webpack_public_path__ + "static/media/lizTable-01.bbdee235.jpg";